module.exports = __webpack_public_path__ + "media/images/svgs/sub_menu/app/apple_plus-3b9a2362979e1f5ad2715d22ddb41825.svg";